module.exports = "/_next/static/images/tw-587d478a5c930584e1cd9a01a49220c8.svg";